import { inject, provide } from "@vue/composition-api";

const SOUNDKITS_FILTER_CONTEXT_TOKEN = 'SOUNDKITS_FILTER_CONTEXT_TOKEN'

/**
 * @param {{selected: {type, tag, instrument, added, sortBy}}} state
 */
export function provideSoundkitsFilterContext(state) {
  provide(SOUNDKITS_FILTER_CONTEXT_TOKEN, state)
}

/**
 * @return {{selected: {type, tag, instrument, added, sortBy}}}
 */
export function useSoundkitsFilterContext() {
  return inject(SOUNDKITS_FILTER_CONTEXT_TOKEN)
}
